<vitamui-common-confirm-dialog
  [dialogTitle]="'COMMON.UNDO_MODAL.UNDO_MESSAGE' | translate"
  [dialogSubTitle]="'COMMON.UNDO_MODAL.TITLE' | translate"
  [confirmLabel]="'COMMON.CLOSE' | translate"
  [cancelLabel]="'COMMON.UNDO' | translate"
>
</vitamui-common-confirm-dialog>
